import { Cell } from 'react-table'

import { ConfigFile } from 'components/Icons'
import { StyledConfigName } from '../styles'

export const ConfigNameCell = (cell: Cell) => (
  <StyledConfigName>
    <ConfigFile />
    <span>{cell.value}</span>
  </StyledConfigName>
)
